import React, { PropsWithChildren, useEffect, useState } from 'react';
import { vibrate } from '../../Utils/Helpers';
import { TbChevronDown, TbX } from 'react-icons/tb';
import { Popover, PopoverButton, PopoverPanel } from "@headlessui/react";
import { ImSpinner8 } from 'react-icons/im';

interface PopoverCustomProps {
  list: any[];
  onClick: CallableFunction;
  onClear: CallableFunction;
  disabled?: boolean;
  className?: string;
  outline?: boolean;
  loading?: boolean;
  placeholder?: string;
  current?: string | null;
  disabledWhenSelected?: boolean;
}

const PopoverCustom = ({
  list = [],
  onClick = () => {},
  onClear = () => {},
  disabled = false,
  className,
  outline = false,
  loading = false,
  placeholder = 'Selecione',
  current = null,
  disabledWhenSelected = false,
}: PropsWithChildren<PopoverCustomProps>) => {

  useEffect(() => {
    setSelected(current);
  }, [current]);

  const [selected, setSelected] = useState<string | null>();
  const handleClick = (item: string) => {
    setSelected(item);
    onClick(item);
    vibrate();
  }
  const handleClear = () => {
    setSelected(null);
    onClear();
    vibrate();
  }

  return (
    <Popover className={`
      relative flex w-auto max-w-full justify-center px-4 py-1 rounded-full h-11 ring-2
      ${outline ? 'text-custom-primary hover:text-custom-primary-hover ring-gray-200' : 'text-white ring-custom-primary bg-custom-primary hover:bg-custom-primary-hover'}
      ${disabled ? 'opacity-50 pointer-events-none' : ''}
      ${className}
    `}>
      {({ open, close }) => (
        <>
          <PopoverButton className={`
              inline-flex gap-4 items-center justify-between w-full focus:outline-none focus:ring-0
            `}>
              <span className={`${!selected ? 'text-nowrap' : ''} font-semibold`}>{loading ? 'Carregando...' : selected || placeholder}</span>
              <div className='flex items-center gap-1'>
                {selected && <span 
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      handleClear();
                      close();
                    }}
                    className='cursor-pointer p-1 text-gray-500 right-2 hover:bg-gray-200 rounded-full transition-all  duration-200'
                    ><TbX />
                  </span>}
                  {loading ? <ImSpinner8 size={18} className="animate-spin" /> : <span className={`transform transition-transform duration-[250ms] ${open ? '-rotate-180' : 'rotate-0'}`}><TbChevronDown size={18} /></span>}
              </div>
          </PopoverButton>

          <PopoverPanel
              transition
              className="absolute z-10 flex top-12 mt-1 w-full -translate-x-0 transition data-[closed]:translate-y-1 data-[closed]:opacity-0 data-[enter]:duration-200 data-[leave]:duration-150 data-[enter]:ease-out data-[leave]:ease-in"
          >
              <div className="max-w-auto flex-auto overflow-y-auto w-auto max-h-[200px] divide-red-500 rounded-lg text-gray-600 bg-white shadow-lg ring-1 ring-gray-900/5">
                  <div className="overflow-hidden divide-y divide-gray-100">
                      {(list && list.length > 0) ? list.map((item) => (
                          <div key={item} className="group relative flex hover:bg-gray-50 transition-all duration-200">
                              <span onClick={() => {
                                  handleClick(item);
                                  close();
                                }} className={`
                                  flex items-center gap-1 w-full font-semibold text-sm p-3 leading-4
                                  ${disabledWhenSelected && selected === item ? 'bg-gray-50 pointer-events-none' : 'cursor-pointer'}
                                `}>
                                {item}
                              </span>
                          </div>
                      )) : (
                        <div className="flex items-center gap-1 w-full font-semibold text-sm p-3 leading-4">
                          ---
                        </div>
                      )}
                  </div>
              </div>
          </PopoverPanel>
      </>
      )}
  </Popover>
  )
}

export default PopoverCustom;